import { CampaignDetailModel, CampaignStage } from '@urbanx/agx-ui-components';
import { getEnumValue } from 'helpers/enumHelper';
import { Tabs } from 'types/Tabs';
import ResumeFormDetails from '../Common/ResumeFormDetails';
import AgencyAgreementSigningPanel from './AgencyAgreementSigningPanel';

interface AgencyAgreementInfoPanelProps {
  campaign: CampaignDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
}

const AgencyAgreementInfoPanel = ({
  campaign,
  currentTab,
  mobile = false,
}: AgencyAgreementInfoPanelProps) => {
  const campaignStage = getEnumValue(CampaignStage, campaign.stage);

  switch (campaignStage) {
    case CampaignStage.AgreementDraft:
      return (
        <ResumeFormDetails
          currentTab={currentTab}
          campaign={campaign}
          mobile={mobile}
        />
      );
    case CampaignStage.AgreementVendorSigning:
    case CampaignStage.AgreementAgentSigning:
    case CampaignStage.AgreementSignedByAllParties:
      return (
        <AgencyAgreementSigningPanel
          currentTab={currentTab}
          campaign={campaign}
          mobile={mobile}
        />
      );
    default:
      return null;
  }
};

export default AgencyAgreementInfoPanel;
